export const ELIGIBLE_COMPANIES_FOR_MODEL_PER_PAGE = 10;
